<template>
<legal-document title="Политика обработки персональных данных" type="personal-data-policy" />
</template>

<script>
import LegalDocument from './../../components/legal/LegalDocument';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Политика обработки персональных данных'),
    }
  },

  components: {
    LegalDocument,
  },
}
</script>
